/*
 *
 * AmbassadorsSummary constants
 *
 */
export const GET_LANGUAGE_WATCHER = "app/AmbassadorsSummary/GET_LANGUAGE_WATCHER"
  export const GET_LANGUAGE_SUCCESS = "app/AmbassadorsSummary/GET_LANGUAGE_SUCCESS"
  export const GET_LANGUAGE_FAILED = "app/AmbassadorsSummary/GET_LANGUAGE_FAILED"
export const GET_AMBASSADORS_SUMMARY_WATCHER =
  "app/AmbassadorsSummary/GET_AMBASSADORS_SUMMARY_WATCHER"
export const GET_AMBASSADORS_SUMMARY_SUCCESS =
  "app/AmbassadorsSummary/GET_AMBASSADORS_SUMMARY_SUCCESS"
export const GET_AMBASSADORS_SUMMARY_FAILED =
  "app/AmbassadorsSummary/GET_AMBASSADORS_SUMMARY_FAILED"

export const UPLOAD_TEMPLATE_AMBASSADORS_WATCHER =
  "app/AmbassadorsSummary/UPLOAD_TEMPLATE_AMBASSADORS_WATCHER"
export const UPLOAD_TEMPLATE_AMBASSADORS_SUCCESS =
  "app/AmbassadorsSummary/UPLOAD_TEMPLATE_AMBASSADORS_SUCCESS"
export const UPLOAD_TEMPLATE_AMBASSADORS_FAILED =
  "app/AmbassadorsSummary/UPLOAD_TEMPLATE_AMBASSADORS_FAILED"

export const SAVE_EXCEL_AMBASSADORS_WATCHER =
  "app/AmbassadorsSummary/SAVE_EXCEL_AMBASSADORS_WATCHER"
export const SAVE_EXCEL_AMBASSADORS_SUCCESS =
  "app/AmbassadorsSummary/SAVE_EXCEL_AMBASSADORS_SUCCESS"
export const SAVE_EXCEL_AMBASSADORS_FAILED =
  "app/AmbassadorsSummary/SAVE_EXCEL_AMBASSADORS_FAILED"
export const SAVE_EXCEL_AMBASSADORS_PROGRESS =
  "app/AmbassadorsSummary/SAVE_EXCEL_AMBASSADORS_PROGRESS"
